import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-361adc68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_card_kanban = _resolveComponent("card-kanban")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ss-div-coluna ss-fadein",
    style: _normalizeStyle('border-color: ' + _ctx.computedColuna.cor)
  }, [
    (_ctx.computedColuna.titulo !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ss-div-titulo",
          style: _normalizeStyle('background-color: ' + _ctx.computedColuna.cor)
        }, [
          (_ctx.props.selecionavel)
            ? (_openBlock(), _createBlock(_component_a_checkbox, {
                key: 0,
                class: "ss-kanban-coluna-checkbox",
                checked: _ctx.computedColuna.itensSelecionados,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedColuna.itensSelecionados) = $event)),
                onChange: _ctx.atualizarItensSelecionados
              }, null, 8, ["checked", "onChange"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.computedColuna.titulo), 1),
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                style: {"color":"white","margin-left":"2px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickEditarColuna(_ctx.computedColuna.identificador)))
              }, [
                _createVNode(_component_icone, {
                  style: {"margin-bottom":"-2px"},
                  nome: "editar"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                style: {"color":"white","margin-left":"2px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickExcluirColuna(_ctx.computedColuna.identificador)))
              }, [
                _createVNode(_component_icone, {
                  style: {"margin-bottom":"-2px"},
                  nome: "excluir"
                })
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.computedColuna.botaoNovo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "ant-btn ant-btn-primary ss-botao-novo ss-sombra-suave",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickNovo && _ctx.clickNovo(...args)))
          }, _toDisplayString(_ctx.computedColuna.descricaoBotaoNovo), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle('height: calc(100% - ' + _ctx.obterHeightCorpo() +'px);')
    }, [
      _createElementVNode("div", {
        class: "ss-div-conteudo",
        style: _normalizeStyle(_ctx.computedColuna.colunaAdicao ? 'overflow-y: hidden;': '')
      }, [
        (_ctx.computedColuna.colunaAdicao)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ss-drag-cards",
              style: {"cursor":"pointer"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickNovaColuna && _ctx.clickNovaColuna(...args)))
            }, [
              _createVNode(_component_icone, {
                style: {"font-size":"100px","height":"100%"},
                nome: "novo"
              })
            ]))
          : (_openBlock(), _createBlock(_component_draggable, {
              key: 1,
              class: "ss-drag-cards",
              list: _ctx.computedColuna.cards,
              group: "cards",
              itemKey: "identificador",
              handle: ".ss-mover",
              onSort: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ordemCardsAlterada(_ctx.computedColuna.identificador)))
            }, {
              item: _withCtx(({ element, index }) => [
                (_openBlock(), _createBlock(_component_card_kanban, {
                  key: element.identificador,
                  cor: _ctx.computedColuna.cor,
                  identificadorColuna: _ctx.computedColuna.identificador,
                  card: _ctx.computedColuna.cards[index],
                  "onUpdate:card": ($event: any) => ((_ctx.computedColuna.cards[index]) = $event),
                  selecionavel: _ctx.props.selecionavel,
                  onSelecaoAlterada: _ctx.selecaoCardAlterada,
                  onColunaAlterada: _ctx.colunaCardAlterada,
                  onClickVisualizar: _ctx.clickVisualizar,
                  onClickSelecionar: _ctx.atualizarQtdSelecionados,
                  onClickSubMenu: _ctx.clickSubMenu
                }, {
                  menus: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "menus", {}, undefined, true)
                  ]),
                  _: 2
                }, 1032, ["cor", "identificadorColuna", "card", "onUpdate:card", "selecionavel", "onSelecaoAlterada", "onColunaAlterada", "onClickVisualizar", "onClickSelecionar", "onClickSubMenu"]))
              ]),
              _: 3
            }, 8, ["list"]))
      ], 4)
    ], 4),
    (_ctx.UtilitarioGeral.valorValido(_ctx.computedColuna.textoTotalizador))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "ss-div-rodape",
          style: _normalizeStyle('font-size:13px;color: ' + _ctx.computedColuna.cor)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.computedColuna.textoTotalizador) + ": " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.computedValorTotalizador,2, true)), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 4))
}